import { render, staticRenderFns } from "./attachmentUpload.vue?vue&type=template&id=e230a716&scoped=true&"
import script from "./attachmentUpload.vue?vue&type=script&lang=js&"
export * from "./attachmentUpload.vue?vue&type=script&lang=js&"
import style0 from "./attachmentUpload.vue?vue&type=style&index=0&id=e230a716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e230a716",
  null
  
)

export default component.exports